// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"491c4d47","387":"64ece69e","487":"04115f8f","547":"4ffe3534"}[chunkId] + ".chunk.js";
};